import { toast } from 'sonner'
import { fbt } from 'fbtee'
import { unlinkGroupEvent } from './groupUnlink'

/** "Linked X" with an Undo: once others react to a link, only an admin can remove it. */
export function toastGroupLinked(groupName: string, link: { id: string; groupId: string; eventId: string }) {
  toast.success(
    fbt(
      'Linked ' + fbt.param('group', groupName) + ' to this event',
      'Toast confirming a group was linked to an event from the post-RSVP prompt',
    ),
    {
      action: {
        label: fbt('Undo', 'Toast button that unlinks a group right after linking it to an event').toString(),
        onClick: () => void unlinkGroupEvent(link, 'undo_toast'),
      },
    },
  )
}

export function toastGroupAlreadyLinked(groupName: string) {
  toast.success(
    fbt(
      fbt.param('group', groupName) + ' is already linked to this event',
      'Toast shown when the group the user tried to link was already linked',
    ),
  )
}
